export enum Day1EventCategory {
  AmazonUsername = "AMAZON-USERNAME",
  BlockingError = "BLOCKING-ERROR",
  Complete = "COMPLETE",
  ConnectToVpn = "CONNECT-TO-VPN",
  CreateAmazonPassword = "CREATE-AMAZON-PASSWORD",
  IDCheckFull = "IDENTITY-CHECK-FULL",
  IDCheckFullPri = "IDENTITY-CHECK-FULL-PRI",
  IDCheckFullSec = "IDENTITY-CHECK-FULL-SEC",
  IDCheckFullWait = "IDENTITY-CHECK-FULL-WAIT",
  IDCheckFullChallenge = "IDENTITY-CHECK-FULL-CHALLENGE",
  IDCheckLight = "IDENTITY-CHECK-LIGHTWEIGHT",
  IDCheckLightWait = "IDENTITY-CHECK-LIGHTWEIGHT-WAIT",
  InsertAndTestSecurityKey = "INSERT-AND-TEST-SECURITY-KEY",
  MidwayRegisterSecKey = "MIDWAY-REGISTER-SEC-KEY",
  InstallPrecache = "INSTALL-PRECACHE",
  PageLevel = "PAGE-LEVEL",
  IDVPrefSelect = "IDV-PREF-SELECT",
  RIVAutomatedConsentOptin = "AUTOMATED-RIV-CONSENT-OPTIN",
  RIVManualConsentOptin = "MANUAL-RIV-CONSENT-OPTIN",
  AutomatedRivScreen = "AUTOMATED-RIV-SCREEN",
  AutomatedRivOutcome = "AUTOMATED-RIV-OUTCOME",
  Header = "HEADER",
  FAQ = "FAQ",
  ContentFeedback = "CONTENT-FEEDBACK",
  VideoPlayback = "VIDEO-PLAYBACK",
  System = "SYSTEM",
  FeatureFlags = "FEATURE-FLAGS",
  Chatbot = "CHATBOT",
  // Unauthenticated landing page shown when the desktop app loads the web app
  // with `?splash=1`. Ported from the Electron native splash screen.
  Landing = "LANDING",
  // Both kept out of ConnectToVpn and the IDCheck*/RIV* categories, whose pairs existing
  // dashboards already read as VPN-step and identity-verification markers.
  AiJourneyConsent = "AI-JOURNEY-CONSENT",
  MacOsPermissions = "MACOS-PERMISSIONS",
}

export enum Day1EventAction {
  INFO = "INFO",
  NotDay1 = "NOT-DAY-1",
  NoStartDate = "NO-START-DATE",
  AccountIssue = "ACCOUNT-ISSUE",
  ChatWithSupport = "CHAT-WITH-SUPPORT",
  NotVerifiable = "NOT-SUPPORTED-MESSAGE-DISPLAYED",
  SectionToggled = "SECTION-TOGGLED",
  SectionDisplayed = "SECTION-DISPLAYED",
  // When the preference was set in PD1 and selected **for** the user.
  IDVAutoSelectAutomatedUsed = "PREV-SELECT-AUTOMATED",

  // When the preference was set in PD1 and selected **for** the user.
  IDVAutoSelectManualUsed = "PREV-SELECT-MANUAL",

  // When the preference is selected by the user.
  IDVSelectManual = "SELECT-MANUAL",

  // When the preference is selected by the user.
  IDVSelectAutomated = "SELECT-AUTOMATED",

  // When the Contact Support card is selected by the user.
  IDVSelectContactSupport = "SELECT-CONTACT-SUPPORT",

  ConfirmationModalDisplayed = "CONFIRMATION-MODAL-DISPLAYED",

  ClickSubmit = "CLICK-SUBMIT",
  IVVIframeLoaded = "IFRAME-LOADED",
  IVVIframeLoadError = "IFRAME-LOAD-ERROR",
  CompletionRedirect = "COMPLETION-REDIRECT",
  ExpiryRedirect = "EXPIRY-REDIRECT",
  ConsentScrollTop = "CONSENT-SCROLL-TOP",
  ConsentScrollBottom = "CONSENT-SCROLL-BOTTOM",
  CheckOptIn = "CHECK-OPT-IN",
  UncheckOptIn = "UNCHECK-OPT-IN",
  ClickCancel = "CLICK-CANCEL",
  ClickAgree = "CLICK-AGREE",
  ClickConfirm = "CLICK-CONFIRM",

  ClickRivSection = "CLICK-RIV-SECTION",
  BackToRivList = "BACK-TO-RIV-LIST",
  SelectCountry = "SELECT-COUNTRY",
  SelectPrimaryId = "SELECT-PRIMARY-ID",
  Continue = "CONTINUE",
  ExpandGuidance = "EXPAND-GUIDANCE",
  CollapseGuidance = "COLLAPSE-GUIDANCE",
  ChallengeAction1Set = "CHALLENGE-ACTION-1-SET",
  ChallengeAction2Set = "CHALLENGE-ACTION-2-SET",
  DisplayWaitUI = "DISPLAY-WAIT-UI",
  CheckRivStatus = "CHECK-RIV-STATUS",
  ShowRivStatus = "SHOW-RIV-STATUS",
  SendTempPin = "SEND-TEMP-PIN",
  SendTempPinResponse = "SEND-TEMP-PIN-RESPONSE",
  ResendTempPin = "RESEND-TEMP-PIN",
  OpenMidwayPortal = "OPEN-MIDWAY-PORTAL",
  CheckedConfirmation = "CHECKED-CONFIRMATION",
  UncheckedConfirmation = "UNCHECKED-CONFIRMATION",
  CloseMidwayPortalManual = "CLOSE-MIDWAY-PORTAL-MANUALLY",
  ClosePasswordToolManual = "CLOSE-PASSWORD-TOOL-MANUALLY",
  OpenPasswordTool = "OPEN-PASSWORD-TOOL",
  GenericError = "GENERIC-ERROR",
  WizardUnload = "WIZARD-UNLOAD",
  WizardLoad = "WIZARD-LOAD",
  RecordVideoClicked = "RECORD-VIDEO-CLICKED",
  SelectGovernmentIssuedId = "SELECT-GOVERNMENT-ISSUED-ID",
  SelectNonGovernmentIssuedId = "SELECT-NON-GOVERNMENT-ISSUED-ID",
  SelectLanguage = "SELECT-LANGUAGE",
  ExpandingFAQ = "EXPANDING-FAQ",
  ShowSelfHelpFAQ = "SHOW-SELF-HELP-FAQ",
  SelectUsefulContent = "SELECT-USEFUL-CONTENT",
  SelectUnusefulContent = "SELECT-UNUSEFUL-CONTENT",
  FeatureFlagAccessed = "FEATURE-FLAG-ACCESSED",

  // When a security key is detected during USB scanning
  SecurityKeyDetected = "SECURITY-KEY-DETECTED",
  // When no security keys are detected during scanning
  NoSecurityKeysDetected = "NO-SECURITY-KEYS-DETECTED",
  // When non-security key USB devices are detected
  NonSecurityKeyDevicesDetected = "NON-SECURITY-KEY-DEVICES-DETECTED",
  // When more than one security key is detected
  MultipleSecurityKeysDetected = "MULTIPLE-SECURITY-KEYS-DETECTED",

  // When no OTP is generated for 30 seconds and error banner appears
  SecurityKeyOtpErrorDisplayed = "SECURITY-KEY-OTP-ERROR-DISPLAYED",
  // When OTP validation succeeds after user presses their key
  SecurityKeyOtpValidated = "SECURITY-KEY-OTP-VALIDATED",
  // When user clicks "Continue without testing" during OTP timeout
  SecurityKeyOtpSkipped = "SECURITY-KEY-OTP-SKIPPED",

  // When the entire security key step completes successfully
  InsertAndTestSecurityKeyStepComplete = "INSERT-AND-TEST-SECURITY-KEY-STEP-COMPLETE",
  // When platform doesn't support the security key step
  InsertAndTestSecurityKeyStepBypassed = "INSERT-AND-TEST-SECURITY-KEY-STEP-BYPASSED",
  // When user clicks "Continue without testing" during detection timeout
  SecurityKeyDetectionSkipped = "SECURITY-KEY-DETECTION-SKIPPED",

  // When user clicks "I don't have a security key" button
  SecurityKeyUnavailableClicked = "SECURITY-KEY-UNAVAILABLE-CLICKED",
  // When user clicks "Report security key issue" button
  SecurityKeyIssueReported = "SECURITY-KEY-ISSUE-REPORTED",
  // When the security key issues modal is opened
  SecurityKeyIssuesModalOpened = "SECURITY-KEY-ISSUES-MODAL-OPENED",
  // When the security key issues modal is closed
  SecurityKeyIssuesModalClosed = "SECURITY-KEY-ISSUES-MODAL-CLOSED",
  // When user clicks "Submit" in the security key issues form
  SecurityKeyIssuesFormSubmitted = "SECURITY-KEY-ISSUES-FORM-SUBMITTED",
  // When user clicks "Cancel and back to setup" in the form
  SecurityKeyIssuesFormCanceled = "SECURITY-KEY-ISSUES-FORM-CANCELED",
  // When user clicks chat support in the issues modal
  SecurityKeyIssuesChatSupportClicked = "SECURITY-KEY-ISSUES-CHAT-SUPPORT-CLICKED",
  // When user reports "My security key hasn't arrived" in Question 1
  SecurityKeyIssuesFormQ1NotArrivedReported = "SECURITY-KEY-ISSUES-FORM-Q1-NOT-ARRIVED-REPORTED",
  // When user reports "I received my security key, but it's not with me right now" in Question 1
  SecurityKeyIssuesFormQ1NotWithMeReported = "SECURITY-KEY-ISSUES-FORM-Q1-NOT-WITH-ME-REPORTED",
  // When user reports "Other, not listed" in Question 1
  SecurityKeyIssuesFormQ1OtherIssueReported = "SECURITY-KEY-ISSUES-FORM-Q1-OTHER-ISSUE-REPORTED",

  // When the isSecurityKeyRegistered status from the GetUserProgress API endpoint comes back as true
  SecurityKeyRegistrationDetected = "SECURITY-KEY-REGISTRATION-DETECTED",
  // When the isSecurityKeyRegistered status
  SecurityKeyRegistrationDetectionTimeout = "SECURITY-KEY-REGISTRATION-DETECTION-TIMEOUT",
  // When the detection flow starts (isSecurityKeyRegistered === false, spinner shown)
  SecurityKeyRegistrationDetectionStarted = "SECURITY-KEY-REGISTRATION-DETECTION-STARTED",
  // When user clicks "Yes, I confirm I have registered" after detection timeout
  SecurityKeyRegistrationTimeoutConfirmed = "SECURITY-KEY-REGISTRATION-TIMEOUT-CONFIRMED",
  // When user clicks "I need help" after detection timeout
  SecurityKeyRegistrationTimeoutNeedHelp = "SECURITY-KEY-REGISTRATION-TIMEOUT-NEED-HELP",

  AIOptInSelected = "AI-OPT-IN-SELECTED",
  AIOptOutSelected = "AI-OPT-OUT-SELECTED",
  AIWorkflowStarted = "AI-WORKFLOW-STARTED",
  AIWorkflowCompleted = "AI-WORKFLOW-COMPLETED",
  AIWorkflowFailed = "AI-WORKFLOW-FAILED",
  AIWorkflowCancelled = "AI-WORKFLOW-CANCELLED",
  AIWorkflowTimeout = "AI-WORKFLOW-TIMEOUT",
  AIWorkflowClientError = "AI-WORKFLOW-CLIENT-ERROR",
  AIWorkflowDuration = "AI-WORKFLOW-DURATION",
  AIWorkflowIterations = "AI-WORKFLOW-ITERATIONS",
  AIWorkflowBackToSetup = "AI-WORKFLOW-BACK-TO-SETUP",
  AIWorkflowManualFallback = "AI-WORKFLOW-MANUAL-FALLBACK",
  ThemeToggle = "THEME-TOGGLE",
  ThemeLoaded = "THEME-LOADED",
  AIControlConsentChecked = "AI-CONTROL-CONSENT-CHECKED",
  AIControlConsentUnchecked = "AI-CONTROL-CONSENT-UNCHECKED",
  ScreenshotDataStorageConsentChecked = "SCREENSHOT-DATA-STORAGE-CONSENT-CHECKED",
  ScreenshotDataStorageConsentUnchecked = "SCREENSHOT-DATA-STORAGE-CONSENT-UNCHECKED",
  // A refusal of session-wide capture, which is remembered and never re-offered. Distinct
  // from AIOptOutSelected, which declines automation for a single step.
  AIJourneyConsentDeclined = "AI-JOURNEY-CONSENT-DECLINED",
  // The hire agreed but the consent write kept failing, so they carried on without the
  // assistant. Counted apart from a refusal: nothing was withheld, the recording failed.
  AIJourneyConsentAbandoned = "AI-JOURNEY-CONSENT-ABANDONED",

  // Conversational chatbot (Aiva) events. Distinct from the AIWorkflow* actions
  // above, which belong to the Electron AI automation feature.
  // When the chatbot is opened by the user (banner launch or tab toggle).
  ChatbotOpened = "CHATBOT-OPENED",
  // When a chatbot conversation session is created.
  ChatbotSessionStarted = "CHATBOT-SESSION-STARTED",
  // When the user sends a message to the chatbot.
  ChatbotMessageSent = "CHATBOT-MESSAGE-SENT",
  // When the chatbot returns a successful response.
  ChatbotResponseReceived = "CHATBOT-RESPONSE-RECEIVED",
  // When a chatbot request fails.
  ChatbotResponseError = "CHATBOT-RESPONSE-ERROR",
  // When the agent decides to hand the conversation off to live IT Support.
  ChatbotEscalationInitiated = "CHATBOT-ESCALATION-INITIATED",
  // When the user explicitly clicks "Talk to IT Support instead".
  ChatbotEscalationClicked = "CHATBOT-ESCALATION-CLICKED",
  // When the user switches from the chatbot back to an already-running live IT
  // Support chat via the header button. Distinct from the escalation actions
  // above: no handoff happens, the user is just returning to an open session.
  ChatbotReturnedToLiveSupport = "CHATBOT-RETURNED-TO-LIVE-SUPPORT",
  // When the user clicks a suggested-topic chip.
  ChatbotSuggestedTopicClicked = "CHATBOT-SUGGESTED-TOPIC-CLICKED",

  // On-demand VPN status check outcomes (Connect VPN step, manual flow).
  // The check runs when the user clicks Next; it never blocks progression.
  // When the check reported an active VPN connection.
  VpnStatusCheckConnected = "VPN-STATUS-CHECK-CONNECTED",
  // When the check reported no active VPN connection.
  VpnStatusCheckDisconnected = "VPN-STATUS-CHECK-DISCONNECTED",
  // When the check found no VPN CLI installed on the machine.
  VpnStatusCheckNotInstalled = "VPN-STATUS-CHECK-NOT-INSTALLED",
  // When the check could not interpret the CLI output (fails open).
  VpnStatusCheckUnknown = "VPN-STATUS-CHECK-UNKNOWN",
  // When the user clicks "Continue anyway" on the not-connected warning.
  VpnStatusCheckContinueAnyway = "VPN-STATUS-CHECK-CONTINUE-ANYWAY",
  // When the user clicks "Check again" on the not-connected warning.
  VpnStatusCheckRetry = "VPN-STATUS-CHECK-RETRY",
  // When the user opens IT Support chat from the not-connected warning.
  VpnStatusCheckChatSupport = "VPN-STATUS-CHECK-CHAT-SUPPORT",

  // Unauthenticated landing page (ported from the Electron native splash).
  // When the landing page mounts.
  LandingLoaded = "LANDING-LOADED",
  // When one of the three audience cards is clicked. The CardType (EZO,
  // FirstAid, LaptopSetup) is sent in the event `property`.
  LandingCardClicked = "LANDING-CARD-CLICKED",
  // When the "I need help" modal is opened.
  LandingHelpModalOpened = "LANDING-HELP-MODAL-OPENED",
  // When the user selects a help option. The option is sent in `property`.
  LandingHelpOptionSelected = "LANDING-HELP-OPTION-SELECTED",
  // When the help form is submitted. The chosen option is sent in `property`.
  LandingHelpFormSubmitted = "LANDING-HELP-FORM-SUBMITTED",
  // When the help modal is cancelled without submitting.
  LandingHelpModalCancelled = "LANDING-HELP-MODAL-CANCELLED",
  // When the post-submission confirmation modal is closed.
  LandingHelpConfirmationClosed = "LANDING-HELP-CONFIRMATION-CLOSED",
  // When the user clicks "Chat with IT" from the confirmation modal.
  LandingChatWithITClicked = "LANDING-CHAT-WITH-IT-CLICKED",

  // macOS grant walkthrough. The hire has already consented; these record whether the
  // operating system let them follow through.
  MacGrantsOutstanding = "MAC-GRANTS-OUTSTANDING",
  // The bridge was absent or the probe threw, so the grants were assumed rather than read.
  MacGrantProbeUnanswered = "MAC-GRANT-PROBE-UNANSWERED",
  MacGrantsHeld = "MAC-GRANTS-HELD",
  MacGrantSettingsOpened = "MAC-GRANT-SETTINGS-OPENED",
  // The host refused or failed to open the pane, so the hire never got there. Kept apart from
  // MAC-GRANT-SETTINGS-OPENED, or a broken bridge reads as a hire who was shown the pane and
  // ignored it.
  MacGrantSettingsOpenFailed = "MAC-GRANT-SETTINGS-OPEN-FAILED",
  MacGrantReportOpened = "MAC-GRANT-REPORT-OPENED",
  MacGrantReportSubmitted = "MAC-GRANT-REPORT-SUBMITTED",
  // A cause was chosen, but the grants arrived before it was sent. Neither a refusal nor a silent
  // dismissal, and the cause is still worth having: it names macOS behaviour the hire recovered from.
  MacGrantReportSuperseded = "MAC-GRANT-REPORT-SUPERSEDED",
  // The walkthrough worked: grants that were outstanding on arrival are now held. The conversion
  // the whole page exists for, and not inferable from the arrival counts alone.
  MacGrantsResolved = "MAC-GRANTS-RESOLVED",
  MacGrantContinued = "MAC-GRANT-CONTINUED",
  MacGrantReportCancelled = "MAC-GRANT-REPORT-CANCELLED",
  MacGrantManualBegun = "MAC-GRANT-MANUAL-BEGUN",
  MacGrantForwardedAfterReport = "MAC-GRANT-FORWARDED-AFTER-REPORT",
  // ID still capture (manual RIV): outcome of automatic frame selection during
  // the ID recording. The variant (auto | fallback | none) is sent in the
  // event's `property`. "none" = capture was enabled but no still was produced.
  IdStillCaptureOutcome = "ID-STILL-CAPTURE-OUTCOME",
  // Whether the new hire accepted the captured still or retook it, sent in
  // `property` (accepted | retried), with the capture source in `label`.
  IdStillDecision = "ID-STILL-DECISION",
}

export enum Day1EventLabel {
  NotDay1 = "NOT-DAY-1",
  NoStartDate = "NO-START-DATE",
  AccountIssue = "ACCOUNT-ISSUE",
  GenericError = "GENERIC-ERROR",
  PrimaryId = "PRIMARY-ID",
  SecondaryId = "SECONDARY-ID",
  ChallengeAction = "CHALLENGE-ACTION",
  IDCheckFullFail = "IDENTITY-CHECK-FULL-FAIL",
  IDCheckLightFail = "IDENTITY-CHECK-LIGHTWEIGHT-FAIL",
  IDVerificationChime = "IDENTITY-CHECK-CHIME",
  WaitForResult = "WAITING-FOR-RESULTS",
  ResultPass = "RESULT-PASS",
  ResultFail = "RESULT-FAIL",
  ResultExpiry = "RESULT-EXPIRY",
  UnableToCompleteChallenge = "UNABLE-TO-COMPLETE-CHALLENGE",
  OpenChatSupportPanel = "OPEN-CHAT-SUPPORT-PANEL",
  CloseChatSupportPanel = "CLOSE-CHAT-SUPPORT-PANEL",
  StartSupportChat = "START-SUPPORT-CHAT",
  MIDWAY_ERROR_100 = "EZO-MW-ERROR-100",
  MIDWAY_ERROR_200 = "EZO-MW-ERROR-200",
  MIDWAY_ERROR_300 = "EZO-MW-ERROR-300",
  MIDWAY_ERROR_429 = "EZO-MW-ERROR-429",
  MIDWAY_ERROR_999 = "EZO-MW-ERROR-999",
  MIDWAY_SUCCESS = "EZO-MW-SUCCESS",
  IDVSelectedAutomated = "SELECT-AUTOMATED",
  IDVSelectedManual = "SELECT-MANUAL",
  OptedIn = "OPTED-IN",
  NotOptedIn = "NOT-OPTED-IN",
  ConsentConfirmedTrue = "CONSENT-CONFIRMED",
  ConsentConfirmedFalse = "CONSENT-NOT-CONFIRMED",
  LocationConfirmationTrue = "LOC-CONFIRMED",
  LocationConfirmationFalse = "LOC-NOT-CONFIRMED",
  SelectGovernmentIssuedId = "SELECT-GOVERNMENT-ISSUED-ID",
  SelectNonGovernmentIssuedId = "SELECT-NON-GOVERNMENT-ISSUED-ID",
  MoreHelp = "MORE_HELP",
  HostName = "HOSTNAME",

  /* macOS grant walkthrough. Pinned here so the label column stays one casing. */
  MacGrantAccessibility = "MAC-GRANT-ACCESSIBILITY",
  MacGrantScreenRecording = "MAC-GRANT-SCREEN-RECORDING",
  /* Both outstanding. A single value, because a joined list cannot be grouped by. */
  MacGrantsBothOutstanding = "MAC-GRANTS-BOTH-OUTSTANDING",
  MacGrantCauseStatusStale = "MAC-GRANT-CAUSE-STATUS-STALE",
  MacGrantCauseAppMissing = "MAC-GRANT-CAUSE-APP-MISSING",
  MacGrantCauseToggleReverts = "MAC-GRANT-CAUSE-TOGGLE-REVERTS",
  MacGrantCauseOther = "MAC-GRANT-CAUSE-OTHER",
}

export enum Day1EventProperty {
  Pass = "PASS",
  Fail = "FAIL",
}
